import { Toast as BaseToast } from '@base-ui/react/toast';
import type { JSX } from 'react';
import { ToastItem } from './ToastItem.js';
import { useToastManager } from './useToastManager.js';
import * as styles from './Toast.css.js';

export function ToastViewport({
  closeLabel,
  label,
  position,
}: {
  readonly closeLabel: string;
  readonly label: string;
  readonly position: 'top-right' | 'bottom-right';
}): JSX.Element {
  const { toasts } = useToastManager();
  return (
    <BaseToast.Viewport className={styles.viewport} aria-label={label} data-position={position}>
      {toasts.map((toast) => (
        <ToastItem key={toast.id} toast={toast} closeLabel={closeLabel} />
      ))}
    </BaseToast.Viewport>
  );
}
